import type { TagJSONObject } from '@ikegps/core-api';
import { ImageButton } from '../../components/button/image.button';
import { MaterialIcon } from '../../components/icon/icons';
import { addStyles, DefaultTheme } from '../../components/theme';
import { m, type MithrilVNode } from '../../mithril';
import { AppStore } from '../../store';
import { TagIcon } from '../tag.icon/tag.icon';

const CSS = {
	container: 'c-JobCard',
	chip: 'c-JobCard--Chip',
	readonly: 'c-JobCard--ReadOnly',
	content: 'c-JobCard__Content',
	icon: 'c-JobCard__Icon',
	name: 'c-JobCard__Name',
};

const Style = {
	[CSS.container]: {
		display: 'flex',
		'align-items': 'center',
		cursor: 'pointer',
		'text-align': 'left',
		'line-height': DefaultTheme.space(4),
	},
	[CSS.chip]: {
		'background-color': DefaultTheme.background.lightGrey,
		'border-radius': DefaultTheme.space(6),
	},
	[CSS.icon]: {
		'margin-right': DefaultTheme.space(1),
		height: '32px',
		width: '32px',
	},
	[CSS.name]: {
		'margin-right': DefaultTheme.space(3),
	},
};

addStyles(Style);

export interface JobModalCardCtx {
	tag: TagJSONObject;
	action?: (e: MouseEvent) => any;
	cancel?: (e: MouseEvent) => any;
}

export const JobModalCard = {
	viewCard(ctx: JobModalCardCtx, content?: MithrilVNode[]): MithrilVNode {
		const summary = AppStore.TagSummary.get(ctx.tag.objectId);

		return m('div', { className: CSS.container, onclick: ctx.action }, [
			m('div', { className: CSS.icon }, TagIcon.view(ctx.tag, summary)),
			m('div', { className: CSS.content }, [m('span', content != null ? content : ctx.tag.name)]),
		]);
	},
	viewChip(ctx: JobModalCardCtx): MithrilVNode {
		const summary = AppStore.TagSummary.get(ctx.tag.objectId);

		return m('div', { className: `${CSS.container} ${CSS.chip}` }, [
			m('div', { className: CSS.icon }, TagIcon.view(ctx.tag, summary)),
			m('div', { className: CSS.name }, ctx.tag.name),
			ImageButton.view(MaterialIcon.CLOSE, { onclick: ctx.cancel }),
		]);
	},
};
